var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37332 0.34502C11.2601 0.34502 14.4302 2.93623 14.4302 6.07876C14.4302 9.24886 11.2601 11.8125 7.37332 11.8125C6.29824 11.8125 5.30586 11.6195 4.39618 11.2887C3.7346 11.8401 2.35629 12.6946 0.536935 12.6946C0.42667 12.6946 0.371538 12.667 0.316406 12.5843C0.28884 12.5017 0.316406 12.3914 0.371538 12.3363C0.371538 12.3087 1.52931 11.0958 1.88767 9.68991C0.895293 8.69754 0.316406 7.45706 0.316406 6.07876C0.316406 2.93623 3.45894 0.34502 7.37332 0.34502ZM3.84486 6.96087C4.31348 6.96087 4.72698 6.57495 4.72698 6.07876C4.72698 5.61014 4.31348 5.19665 3.84486 5.19665C3.34867 5.19665 2.96275 5.61014 2.96275 6.07876C2.96275 6.57495 3.34867 6.96087 3.84486 6.96087ZM7.37332 6.96087C7.84194 6.96087 8.25543 6.57495 8.25543 6.07876C8.25543 5.61014 7.84194 5.19665 7.37332 5.19665C6.87713 5.19665 6.4912 5.61014 6.4912 6.07876C6.4912 6.57495 6.87713 6.96087 7.37332 6.96087ZM10.9018 6.96087C11.3704 6.96087 11.7839 6.57495 11.7839 6.07876C11.7839 5.61014 11.3704 5.19665 10.9018 5.19665C10.4056 5.19665 10.0197 5.61014 10.0197 6.07876C10.0197 6.57495 10.4056 6.96087 10.9018 6.96087Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/ChatMessage.b2bef6d72424c160e712867be79ef9fa.svg";
export { ForwardRef as ReactComponent };